<template>
    <div class="container">
        <h4>Get report for selected month {{ monthlyReportText }}</h4>
        <div class="d-row-3">
            <div>
                <label>Month</label>
                <VueDatePicker v-model="state.dateMonth" month-picker :clearable="false">
                </VueDatePicker>
            </div>
            <div class="d-checkbox">
                <label for="weekly">Weekly</label>
                <input type="checkbox" name="weekly" id="weekly" v-model="state.monthlyOptions.weekly">
                <label for="daily">Daily</label>
                <input type="checkbox" name="daily" id="daily" v-model="state.monthlyOptions.daily">
            </div>
            <div class="buttons">
                <button class="accent" @click="getMonthlyReport">Get report</button>
            </div>
        </div>
    </div>
    <div style="height: 1rem;"></div>
    <div class="container">
        <h4>Get site work report for selected time period {{ siteWorkReportText }}</h4>
        <div class="d-row-3">
            <div>
                <label>Time period to report</label>
                <VueDatePicker v-model="state.siteWorkPeriod" month-picker range :clearable="false">
                </VueDatePicker>
            </div>
            <div></div>
            <div class="buttons">
                <button class="accent" @click="getSiteWorkReport">Get report</button>
            </div>
        </div>
    </div>    
    <LoadingDownloandScreen v-if="state.showLoading"></LoadingDownloandScreen>
</template>

<script setup lang="ts">
import LoadingDownloandScreen from "@/components/util/LoadingDownloadScreen.vue";
import { computed, reactive } from "vue";
import { useReportStore } from "@/stores/report";
import { showToastError } from "@/toastification";
import { parseError } from "@/common/util";

const state = reactive({
    dateMonth: { year: (new Date).getFullYear(), month: (new Date).getMonth() },
    monthlyOptions: { weekly: true, daily: true },
    showLoading: false,
    siteWorkPeriod: [ { year: (new Date).getFullYear(), month: (new Date).getMonth() }, { year: (new Date).getFullYear(), month: (new Date).getMonth()} ]
});

const reportStore = useReportStore();

const monthlyReportText = computed(() => {
    let result = "";
    if (state.monthlyOptions.weekly || state.monthlyOptions.daily) {
        result = "with ";
        if (state.monthlyOptions.weekly && state.monthlyOptions.daily) {
            result += "weekly and daily ";
        }
        else if (state.monthlyOptions.weekly) {
            result += "weekly ";
        }
        else if (state.monthlyOptions.daily) {
            result += "daily ";
        }
    }
    return result;
});

const siteWorkReportText = computed(() => {
    let result = "Generate Site work report from - to ";
    return result;
})

async function getMonthlyReport() {
    state.showLoading = true;
    try {
        await reportStore.downloadMonthly(state.dateMonth.year, state.dateMonth.month + 1,
            state.monthlyOptions.weekly, state.monthlyOptions.daily);
    }
    catch (e) {
        console.error(e);
        showToastError("Report was unable to generate: " + parseError(e));
    }
    finally {
        state.showLoading = false;
    }
}

async function getSiteWorkReport() {
    state.showLoading = true;
    try {
        if (state.siteWorkPeriod.length != 2) {
            showToastError("Error in entered time period.")
            return 
        }
        await reportStore.downloadSiteWork(
                state.siteWorkPeriod[0].year, 
                state.siteWorkPeriod[0].month + 1,  
                state.siteWorkPeriod[1].year,
                state.siteWorkPeriod[1].month + 1);
    } catch (e) {
        console.error(e);
        showToastError("Report was unable to generate: " + parseError(e));        
    } finally {
        state.showLoading = false;
    }
}

</script>

<style scoped lang="scss">
.d-checkbox {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
</style>